import gsap from 'gsap'

export class ImageInnerParallax {
  constructor({ container, image, position, start, end, scrub = true, value = 20 }) {
    this.container = container
    this.image = image
    this.position = position
    this.start = start
    this.end = end
    this.scrub = scrub
    this.value = value

    this.init()
  }

  init() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.container,
        start: this.start,
        end: this.end,
        scrub: this.scrub
      }
    })

    if (this.position === 'top') {
      tl.fromTo(this.image, {
        top: '-' + this.value + '%'
      }, {
        top: '0%'
      })
    } else if (this.position === 'left') {
      tl.fromTo(this.image, {
        left: '-' + this.value + '%'
      }, {
        left: '0%'
      })
    } else if (this.position === 'bottom') {
      tl.fromTo(this.image, {
        bottom: '-' + this.value + '%'
      }, {
        bottom: '0%'
      })
    }
  }
}

export default function createImageInnerParallax(config) {
  return new ImageInnerParallax(config)
}
